import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'
import { Container as ChevronFlip } from '@subaio/components/src/ChevronFlip/Container'

import { helpers } from 'styles'

export const Button = styled(ButtonPlain)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	width: 100%;
	padding: 12px;
	color: ${helpers.color.text};
	font: inherit;

	&:hover {
		background-color: ${helpers.color.primaryTranslucent};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	> ${ChevronFlip} {
		margin-bottom: 4px;
	}
`
